import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ViewChildren,
  QueryList,
  OnDestroy,
} from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import Helper from 'src/app/core/utility/helper';
import { Constants } from '../../../core/constants';
import { AdhocDueDateExtensionRequestHistoryDTO } from '../../../models/internal/adhocDueDateExtensionRequestHistory-dto';
import { UpdateAdhocDDExtensionStatusDTO } from '../../../models/internal/updateAdhocDDExtensionStatus-dto';
import { SourceIdList } from '../../../models/internal/SourceIdList';

@Component({
  selector: 'app-pe-adhocduedate-extension-request-dashboard',
  templateUrl: './pe-adhocduedate-extension-request-dashboard.component.html',
  styleUrls: ['./pe-adhocduedate-extension-request-dashboard.component.scss']
})
export class PeAdhocduedateExtensionRequestDashboardComponent extends BaseGridPage implements OnInit, AfterViewInit {

  adhocDDERequestList: AdhocDueDateExtensionRequestHistoryDTO[];
  allItemsCheckBoxSelected: boolean = false;
  updateAdhocDDExtensionStatus: UpdateAdhocDDExtensionStatusDTO = new UpdateAdhocDDExtensionStatusDTO;
  ListofSelectedIds: SourceIdList = new SourceIdList;

  constructor(
    private toastService: ToastService,
    private dataService: DataService,
    private fb: FormBuilder,
    localstorageService: LocalstorageService,
    logger: NGXLogger,
    appSettings: AppSettings,
    public formService: FormService,
    private router: Router
  ) {
    super(localstorageService, logger, appSettings);
  }

  /*TMS-20775 
  Introduce a new screen for PE which can list down the total requested due dates extensions. 
  PE makes decision to approve/reject requests  
  */
  ngOnInit() {
    this.fillGrid();
  }

  getAdhocDDERequests() {
    this.dataService.getAdhocDDERequestList().subscribe((response: any) => {
      if (response && response.Data != null) {
        this.adhocDDERequestList = response.Data;
        this.gridView = of({
          data: response.Data,
          total: response.Total ? response.Total : 0,
        });
      }
    });
  }

  fillGrid(): void {
    this.allItemsCheckBoxSelected = false;
    this.getAdhocDDERequests();
  }

  formatDate(unformattedDate: Date) {
    return Helper.formatDate(unformattedDate);
  }

  approveAdhocDDERequest() {
    this.updateAdhocDDExtensionStatus.AdHocDueDateExtensionRequestStatusId = Constants.AdhocDDE_APPROVED_STATUS_ID;
    this.updateDTOAndRequestStatus();
  }

  rejectAdhocDDERequest() {
      this.updateAdhocDDExtensionStatus.AdHocDueDateExtensionRequestStatusId = Constants.AdhocDDE_REJECTED_STATUS_ID;
      this.updateDTOAndRequestStatus();
  } 

  //Create function to update status either to approve or reject for adhoc request
  //TMS-21403 Create a request dto which can accept multiple adhoc request Id along with StatusID to update status
  updateAdhocDDERequestStatus(UpdateAdhocDDExtensionStatusDTO: UpdateAdhocDDExtensionStatusDTO) {
    this.dataService.updateAdhocDDERequestStatus(UpdateAdhocDDExtensionStatusDTO).subscribe((response: any) => {
      if (response != null && response.Success) {
        this.toastService.success('Due Date Extension request status updated successfully', true);
        this.fillGrid();
      } else {
        this.toastService.error(
          'Could not update the status of the request'
        );
      }
    });
  }

  //TMS-21403 Call helper method to update list of ids based on select/deselect event
  onRowSelectedChange(AdhocDueDateExtensionRequestHistoryDTO: AdhocDueDateExtensionRequestHistoryDTO) {
    this.ListofSelectedIds = Helper.onRowSelectedChange(AdhocDueDateExtensionRequestHistoryDTO, this.ListofSelectedIds);
  } 

  //Function will fill dto and update status for the selected request
  updateDTOAndRequestStatus() {
    if (Helper.confirmAdhocDDERequestAction()) {
      this.updateAdhocDDExtensionStatus.Ids = this.ListofSelectedIds.Ids;
      this.updateAdhocDDERequestStatus(this.updateAdhocDDExtensionStatus);
    }
    else {
      this.toastService.info('Request cancelled');
    }
  }

}
